
define('template!adminNotificationsListHeaderToolsView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="user-notification-preferences">\n    ' +
((__t = ( _.i18n('common.preferences', 'Preferences') )) == null ? '' : __t) +
'\n</div>';

}
return __p
};});

